import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import schoolApi from "../../api/schoolApi";
import moment from "moment";

import { Helmet } from "react-helmet";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify"; //add by shahir hussain 03-09-2024
import "react-toastify/dist/ReactToastify.css"; //add by shahir hussain 03-09-2024
import { SessionContext } from "../SessionProvider";

const StudentAddmissionEdit = (props) => {
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const { id: routeAdmissionId } = useParams();
  const { selectedSessionId } = useContext(SessionContext) || {};
  const [hasPaidInstallments, setHasPaidInstallments] = useState(
    Number(location?.state?.paid_installments_count || 0) > 0 || location?.state?.has_paid_installments === true
  );

  const navigate = useNavigate();
  const [studentaddmission, setStudentAddmission] = useState({
    fee_type_id: location?.state?.fee_type,
  });
  const [student, setStudent] = useState();
  const [classes, setClasses] = useState();
  const [sessions, setSession] = useState();
  const [parent, setParent] = useState();
  const [discountRecords, setDiscountRecords] = useState();
  const [discountOptions, setDiscountOptions] = useState();
  const [studentInstallments, setStudentInstallments] = useState([]);
  const [feeTypeOptions, setFeeTypeOptions] = useState([]);
  const [disableField, setDisableField] = useState(false);
  const [upcomingTypes, setUpcomingType] = useState({
    Monthly: true,
    "Bi-Monthly": false,
    Quarterly: false,
    "Half Yearly": false,
  });
  let classList;

  useEffect(() => {
    async function related() {
      try {
        const student = await schoolApi.fetchStudents();
        const classes = await schoolApi.getActiveClassRecords();
        const session = await schoolApi.fetchSessions();
        if (student.success) {
          let ar = [];
          student.students.map((item) => {
            var obj = {};
            obj.value = item.id;
            obj.label = item.firstname + " " + item.lastname;
            ar.push(obj);
          });
          setStudent(ar);
        }
        if (classes.success) {
          setClasses(classes.result);
        }
        if (session?.result.length > 0) {
          setSession(session?.result);
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
      }

      const initialSessionId =
        location?.state?.session_id ||
        location?.state?.sessionid ||
        location?.state?.student_info?.session_id ||
        selectedSessionId;

      fetchDiscountLineItems(initialSessionId);
    }
    studentFeeInstallment();
    related();
  }, [location?.state, selectedSessionId]);

  const studentFeeInstallment = async () => {
    try {
      // Fetch Fee Master by class ID
      let feeMasterResult = await schoolApi.fetchFeeMasterByIdOrClassid(
        location?.state?.classid
      );

      const currentSelectedType = feeMasterResult?.result?.find(
        (res) => res.id === studentaddmission?.fee_type_id
      )?.type;

      const currentfee_structure = feeMasterResult?.result?.find(
        (res) => res.id === studentaddmission?.fee_type_id
      )?.type;

      if (feeMasterResult.success) {
        let ar = [];
        feeMasterResult.result.map((item) => {
          if (item.sessionid == location?.state.session_id) {
            if (item.status === "Active") {
              var obj = {};
              obj.value = item.id;
              obj.label = `${item.type} [${item.fee_structure}]`;
              ar.push(obj);
            }
          }
        });
        setFeeTypeOptions(ar);
      } else {
        setFeeTypeOptions([]);
      }

      // Fetch student fee installments
      let result = await schoolApi.fetchStudentFeeInstallments(
        location?.state?.student_addmission_id
      );

      const pendingInstallmentCount = result.result.filter(
        (res) => res.status === "pending"
      );

      let updatedUpcomingType = {};

      // Handle different fee types based on pending installments count
      if (currentSelectedType.includes("Half Yearly")) {
        if (pendingInstallmentCount.length === 1) {
          updatedUpcomingType = {
            "Monthly [New]": true,
            "Monthly [Old]": true,
            "Quarterly [New]": true,
            "Quarterly [Old]": true,
            "Bi-Monthly [Old]": true,
            "Bi-Monthly [New]": true,
            "Half Yearly [Old]": false,
            "Half Yearly [New]": false,
          };
        } else if (pendingInstallmentCount.length === 2) {
          updatedUpcomingType = {
            "Monthly [New]": true,
            "Monthly [Old]": true,
            "Quarterly [New]": true,
            "Quarterly [Old]": true,
            "Half Yearly [New]": false,
            "Half Yearly [Old]": false,
            "Bi-Monthly [New]": true,
            "Bi-Monthly [Old]": true,
          };
        }
      } else if (currentSelectedType.includes("Quarterly")) {
        if (pendingInstallmentCount.length === 1) {
          updatedUpcomingType = {
            "Monthly [New]": true,
            "Monthly [Old]": true,
            "Bi-Monthly [New]": false,
            "Bi-Monthly [Old]": false,
            "Quarterly [New]": false,
            "Quarterly [Old]": false,
            "Half Yearly [New]": false,
            "Half Yearly [Old]": false,
          };
        } else if (pendingInstallmentCount.length === 2) {
          updatedUpcomingType = {
            "Monthly [New]": true,
            "Monthly [Old]": true,
            "Bi-Monthly [New]": true,
            "Bi-Monthly [Old]": true,
            "Quarterly [New]": false,
            "Quarterly [Old]": false,
            "Half Yearly [New]": false,
            "Half Yearly [Old]": false,
          };
        } else if (pendingInstallmentCount.length === 3) {
          updatedUpcomingType = {
            "Monthly [New]": true,
            "Monthly [Old]": true,
            "Bi-Monthly [New]": false,
            "Quarterly [New]": false,
            "Half Yearly [New]": false,
            "Bi-Monthly [Old]": false,
            "Quarterly [Old]": false,
            "Half Yearly [Old]": false,
          };
        } else if (pendingInstallmentCount.length === 4) {
          updatedUpcomingType = {
            "Monthly [New]": true,
            "Monthly [Old]": true,
            "Bi-Monthly [New]": true,
            "Bi-Monthly [Old]": true,
            "Quarterly [New]": false,
            "Quarterly [Old]": false,
            "Half Yearly [New]": false,
            "Half Yearly [Old]": false,
          };
        }
      } else if (currentSelectedType.includes("Bi-Monthly")) {
        updatedUpcomingType = {
          "Monthly [New]": true,
          "Monthly [Old]": true,
          "Bi-Monthly [New]": false,
          "Quarterly [New]": false,
          "Half Yearly [New]": false,
          "Bi-Monthly [Old]": false,
          "Quarterly [Old]": false,
          "Half Yearly [Old]": false,
        };
      } else if (currentSelectedType.includes("Monthly")) {
        updatedUpcomingType = {
          "Monthly [New]": true,
          "Monthly [Old]": true,
          "Bi-Monthly [New]": false,
          "Quarterly [New]": false,
          "Half Yearly [New]": false,
          "Bi-Monthly [Old]": false,
          "Quarterly [Old]": false,
          "Half Yearly [Old]": false,
        };
      }

      if (result.success) {
        setStudentInstallments(result.result);
        if (result.result && result.result.length > 0) {
          const anyPaid = result.result.some(
            (res) => res.status !== "pending" || Number(res?.deposit_amount) > 0
          );
          setHasPaidInstallments(anyPaid);
          if (anyPaid) {
            setDisableField(true);
          } else {
            const allPending = result.result.every(
              (res) => res.status === "pending"
            );
            if (allPending && location?.state?.editable === true) {
              setStudentAddmission((prevState) => ({
                ...prevState,
                student_admission_status: "inactive",
              }));
            }
          }
        }
      } else {
        setStudentInstallments([]);
      }

      // Set upcoming installment types
      setUpcomingType(updatedUpcomingType);
    } catch (error) {
      console.error("Error fetching studentFeeInstallment:", error);
    }
  };


  const fetchDiscountLineItems = async (overrideSessionId) => {
    try {
      const admissionRecordId =
        location?.state?.student_addmission_id ||
        location?.state?.id ||
        routeAdmissionId;

      let result = null;
      if (admissionRecordId) {
        result = await schoolApi.fetchFeeDiscountLineItemsBySt(admissionRecordId);
      }

      const assignedDiscountIds = new Set();
      if (result && !Array.isArray(result) && Array.isArray(result.result)) {
        result.result.forEach((res) => {
          if (res.discountid) {
            assignedDiscountIds.add(res.discountid);
          }
          setDiscountOptions((prevOptions) => {
            if (!prevOptions) {
              prevOptions = [];
            }
            if (!prevOptions.some((prev) => prev.label === res.discount_name)) {
              return [
                ...prevOptions,
                { value: res.discountid, label: res.discount_name },
              ];
            }
            return prevOptions;
          });
        });
      }

      try {
        const sessionId =
          overrideSessionId ||
          location?.state?.session_id ||
          location?.state?.sessionid ||
          location?.state?.student_info?.session_id ||
          studentaddmission?.session_id ||
          studentaddmission?.sessionid ||
          selectedSessionId;

        let discountResults = sessionId
          ? await schoolApi.fetchFeeDiscounts(sessionId)
          : await schoolApi.fetchFeeDiscounts();

        if (discountResults.success && Array.isArray(discountResults.result)) {
          let ar = [];
          discountResults.result.forEach((item) => {
            if (
              (item?.discount?.status &&
                item.discount.status.toLowerCase() !== "inactive") ||
              assignedDiscountIds.has(item?.discount?.id)
            ) {
              var obj = {};
              obj.value = item.discount.id;
              obj.label = item.discount.name;
              ar.push(obj);
            }
          });
          setDiscountRecords(ar);
        } else {
          setDiscountRecords([]);
        }
      } catch (error) {
        console.log("@#error==>", error);
      }
    } catch (error) {
      console.log("ErrorErrorPoint", error);
    }
  };

  const handleIsDefaulterChange = (e) => {
    setStudentAddmission({
      ...studentaddmission,
      [e.target.name]: e.target.checked,
    });
  };

  useEffect(() => {
    if (location.state?.id) {
      let temp2 = {};
      temp2.value = location?.state.classid;
      temp2.label = location?.state.classname;
    }
    if (location.state?.id) {
      let temp2 = {};
      temp2.value = location?.state.parentid;
      temp2.label = location?.state.parentname;
    }
    if (location.state?.id) {
      let temp2 = {};
      temp2.value = location?.state.vehicleid;
      temp2.label = location?.state.vehicle_number;
    }
    if (location.state?.id) {
    
      setStudentAddmission(location?.state);
    }
  }, []);

  const handleChange = (e) => {
    setStudentAddmission({
      ...studentaddmission,
      [e.target.name]: e.target.value,
    });
  };
  const handleDiscounts = (selectedOption) => {
    setDiscountOptions(selectedOption);
  };

  const handleStudent = (e) => {

    setStudentAddmission({
      ...studentaddmission,
      [e.target.name]: e.target.value,
    });
  };

  const checkRequredFields = () => {
    if (
      studentaddmission.id &&
      studentaddmission.id.trim() !== ""
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (studentaddmission?.addmissionstatus === "promoted") {
      toast.error("Cannot edit admission when in view mode (promoted).");
      return;
    }
    if (checkRequredFields()) {
      setValidated(true);
      return;
    }

    if (
      !studentaddmission.status ||
      !studentaddmission.student_addmission_id ||
      !studentaddmission.fee_type
    ) {
      return toast.error("Required field missing");
    }

    let result2 = {};
    // determine if any selected discount is RTE
    const isRteSelected =
      discountOptions &&
      Array.isArray(discountOptions) &&
      discountOptions.some(
        (opt) => opt.label && opt.label.toLowerCase().includes("rte")
      );

    // prepare payload including isrte flag
    const admissionPayload = { ...studentaddmission, isrte: isRteSelected };

    if (studentaddmission.id) {
      result2 = await schoolApi.saveStudentAddmission(admissionPayload);

      if (admissionPayload.status) {
        const updateStudent = await schoolApi.updateStudent(admissionPayload);
      }

      if (discountOptions) {
        let updateDisRec = {
          student_addmission_id: location?.state?.id,
          category: location?.state?.category,
          fee_type: location?.state?.fee_type,
          discounts: discountOptions,
          isrte: isRteSelected,
        };
        let updatedResult = await schoolApi.updateFeeDiscountLineItems(
          updateDisRec
        );
      }

      if (result2.success) {
        // update local state so UI reflects change
        setStudentAddmission(admissionPayload);
        toast.success("Record save successfully");
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    } else {
      result2 = await schoolApi.createStudentAddmission(admissionPayload);

      if (result2) {
        toast.success("Record save successfully");
        setTimeout(() => {
          navigate(-1);
        }, 1500);
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Row>
        <Col lg={10}>
          <Link className="nav-link" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> AdmissionsDetails{" "}
            <i className="fa-solid fa-chevron-right"></i> AdmissionsEdit{" "}
          </Link>
        </Col>
      </Row>
      <Container className="view-form">
        <Form>
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                noValidate
                validated={validated}
              >
                <Row className="view-form-header align-items-center mx-3">
                  <Col lg={3}>Edit Student Addmission</Col>
                  <Col lg={9} className="d-flex justify-content-end">
                      <Button
                        className="btn-sm mx-2"
                        onClick={handleSubmit}
                        disabled={
                          studentaddmission?.addmissionstatus === "promoted"
                        }
                      >
                        Save
                      </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
                <Row className="mx-3">
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Student Name
                      </Form.Label>
                      <Form.Select
                        name="studentid"
                        onChange={handleStudent}
                        // required
                        value={studentaddmission.studentid}
                        disabled={true}
                      >
                        <option value="">-- Select Student --</option>
                        {student &&
                          student.map((res) => (
                            <option key={res.value} value={res.value}>
                              {res.label}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Class Name
                      </Form.Label>
                      <Form.Select
                        name="classid"
                        onChange={handleChange}
                        // required
                        value={studentaddmission.classid}
                        disabled={true}
                      >
                        <option value="">-- Select Class --</option>
                        {classes &&
                          classes.map((res) => (
                            <option key={res.id} value={res.id}>
                              {res.classname}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicAddmissionDate"
                      >
                        Form No
                      </Form.Label>
                      <Form.Control
                        type="text"
                        disabled={true}
                        name="formno"
                        placeholder="Enter Form Number"
                        value={studentaddmission.formno}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        {" "}
                        Date Of Admission{" "}
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="dateofaddmission"
                        placeholder="Enter date of addmission"
                        value={
                          studentaddmission?.dateofaddmission
                            ? moment(
                                studentaddmission.dateofaddmission,
                                "DD-MM-YYYY"
                              ).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={handleChange}
                        disabled={true}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicAddmissionDate"
                      >
                        Session
                      </Form.Label>
                      <Form.Select
                        name="sessionid"
                        value={studentaddmission?.session_id}
                        disabled={true}
                      >
                        <option value="" disabled>
                          -- Select option --
                        </option>
                        {sessions &&
                          sessions?.map((res) => (
                            <option key={res.id} value={res.id}>
                              {res.year}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Parent Name
                      </Form.Label>
                      <Form.Select
                        name="parentid"
                        // onChange={handleChange}
                        value={studentaddmission.parentid}
                        disabled={true}
                      >
                        <option value="">-- Select Parent --</option>
                        <option value={studentaddmission.parentid}>
                          {studentaddmission.parentname}
                        </option>
                        {/* {parent && parent.map((res) => (
                          <option key={res.value} value={res.value}>
                            {res.label}
                          </option>
                        ))} */}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="text-formatted">
                        Fee Installment Type
                      </Form.Label>
                      <Form.Select
                        required
                        name="fee_type"
                        value={studentaddmission?.fee_type}
                        onChange={handleChange}
                        disabled={
                          studentaddmission?.addmissionstatus === "promoted"
                        }
                      >
                        <option value="">-- Select Type --</option>
                        {feeTypeOptions.map((res) => (
                          <option
                            key={res.value}
                            value={res.value}
                            disabled={!upcomingTypes[res.label]}
                          >
                            {res.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form>
                      <Form.Group className="mx-3 fees">
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicClass"
                        >
                          Select Discounts
                        </Form.Label>
                        <Select
                          placeholder="Select discounts"
                          value={discountOptions}
                          onChange={handleDiscounts}
                          options={discountRecords}
                          isMulti={true}
                          name="disount"
                          isDisabled={
                            studentaddmission?.addmissionstatus === "promoted"
                          }
                        ></Select>
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3 fees">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicClass"
                      >
                        Defaulter
                      </Form.Label>
                      <Form.Check
                        type="checkbox"
                        style={{ fontSize: "20px" }}
                        name="is_defaulter"
                        checked={studentaddmission.is_defaulter}
                        onChange={handleIsDefaulterChange}
                        disabled={
                          studentaddmission?.addmissionstatus === "promoted"
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={studentaddmission?.status}
                        onChange={handleChange}
                        required
                        disabled={
                          studentaddmission?.addmissionstatus === "promoted"
                        }
                      >
                        <option value="">-- Select status --</option>
                        <option value="present">Present</option>
                        <option value="dropout">Dropout</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label>Student Admission Status</Form.Label>
                      <Form.Select
                        name="student_admission_status"
                        value={studentaddmission?.student_admission_status || ""}
                        onChange={handleChange}
                        disabled={
                          hasPaidInstallments || studentaddmission?.addmissionstatus === "promoted"
                        }
                      >
                        <option value="">-- Select Status --</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export default StudentAddmissionEdit;
